import { Injectable } from "@angular/core";
import { ButtonColor, CommonActionKey, UCCFilingStatus, UCCFilingStatusLabel, UCCFilingData, HorizontalListData, HorizontalListFactory, SimpleDialogData } from "common";
import moment from "moment";

export const UCCFilingStatusLabels = {
  'undefined': { color: 'mat-grey-bg', icon: 'help', label: UCCFilingStatusLabel.get(UCCFilingStatus.None) },
  [UCCFilingStatus.None]: { color: 'mat-grey-bg', icon: 'help', label: UCCFilingStatusLabel.get(UCCFilingStatus.None) },
  [UCCFilingStatus.Pending]: { color: 'mat-grey-bg', icon: 'help', label: UCCFilingStatusLabel.get(UCCFilingStatus.Pending) },
  [UCCFilingStatus.EnforcementInProgress]: { color: 'mat-grey-bg', icon: 'help', label: UCCFilingStatusLabel.get(UCCFilingStatus.EnforcementInProgress) },
  [UCCFilingStatus.RescindInProgress]: { color: 'mat-grey-bg', icon: 'help', label: UCCFilingStatusLabel.get(UCCFilingStatus.RescindInProgress) },
  [UCCFilingStatus.Recorded]: { color: 'mat-green-bg', icon: 'check_circle', label: UCCFilingStatusLabel.get(UCCFilingStatus.Recorded) },
  [UCCFilingStatus.Enforced]: { color: 'mat-green-bg', icon: 'check_circle', label: UCCFilingStatusLabel.get(UCCFilingStatus.Enforced) },
  [UCCFilingStatus.Rejected]: { color: 'mat-red-bg', icon: 'error', label: UCCFilingStatusLabel.get(UCCFilingStatus.Rejected) },
  [UCCFilingStatus.Rescinded]: { color: 'mat-red-bg', icon: 'error', label: UCCFilingStatusLabel.get(UCCFilingStatus.Rescinded) },
};

export const PROVISIONAL_UCC_FILING_DOCUMENT = 'provisional';

export const UCCFilingDocumentLabels = {
  [PROVISIONAL_UCC_FILING_DOCUMENT]: {
    color: 'mat-grey-bg',
    icon: 'info',
    label: 'Provisional',
    tooltip: 'Generated by the filing service before recording; replaced by the state-issued document once recorded',
  },
};

@Injectable()
export class EntityUCCFilingWidgetAdapter {
    adaptListData = (data: UCCFilingData, writePermissions: boolean): HorizontalListData[] => {
        return [
            HorizontalListFactory.createCustomTemplateItem({
                customTemplateName: "resubmitUCC1FilingTemplate",
                isItemHidden: !writePermissions || !data?.canResubmitUCC
            }),
            HorizontalListFactory.createCustomTemplateItem({
                customTemplateName: "refreshUCC1Template",
                isItemHidden: !data?.canRefreshUCC
            }),
            HorizontalListFactory.createKeyValueCustomValueTemplateItem({
                title: 'UCC Status',
                customTemplateName: 'uccFilingStatusValueTemplate'
            }),
            HorizontalListFactory.createKeyValueStringItem({
                title: 'UCC Filed Timestamp',
                displayedValue: moment(data?.pendingOnUtc).format('M/D/YYYY h:mm A'),
                isItemHidden: data?.status !== UCCFilingStatus.Pending && data?.status !== UCCFilingStatus.Recorded || !data?.pendingOnUtc
            }),
            HorizontalListFactory.createKeyValueStringItem({
                title: 'UCC Enforced Timestamp',
                displayedValue: moment(data?.enforcedOnUtc).format('M/D/YYYY h:mm A'),
                isItemHidden: data?.status !== UCCFilingStatus.EnforcementInProgress && data?.status !== UCCFilingStatus.Enforced || !data?.enforcedOnUtc
            }),
            HorizontalListFactory.createKeyValueStringItem({
                title: 'UCC Rescinded Timestamp',
                displayedValue: moment(data?.rescindedOnUtc).format('M/D/YYYY h:mm A'),
              isItemHidden: data?.status !== UCCFilingStatus.RescindInProgress && data?.status !== UCCFilingStatus.Rescinded || !data?.rescindedOnUtc
            }),
            HorizontalListFactory.createKeyValueStringItem({
                title: 'UCC Order Number',
                displayedValue: data?.workOrderId || '-'
            }),
            HorizontalListFactory.createCustomTemplateItem({
                customTemplateName: "downloadUCC1Document",
                isItemHidden: !data?.document
            }),
            HorizontalListFactory.createKeyValueStringItem({
                title: 'Errors',
                isValueHidden: !data?.errors,
                displayedValue: data?.errors?.join('\n')
            })
        ]
    }
}

export const getInitializeUCC1DialogData = (): SimpleDialogData => {
  return {
    title: 'Resubmit UCC Filing',
    body: 'Confirm UCC filing resubmission?',
        actions: [
            { label: "CANCEL", buttonColor: ButtonColor.Default, actionKey: CommonActionKey.Cancel },
            { label: "CONFIRM", buttonColor: ButtonColor.Primary, actionKey: CommonActionKey.Confirm },
        ],
  }
}
